import { useCallback, useEffect, useState } from "react";

export function useGetAssetsAspectRatio() {
  const [aspectRatio, setAspectRatio] = useState("");
  const [isVertical, setIsVertical] = useState(false);
  const [loading, setLoading] = useState(false);
  const calculateAspectRatio = useCallback(
    async (attrs, type, getVideoAspect) => {
      if (loading) return;
      setLoading(true);

      const { src, actualWidth, actualHeight } = attrs;
      if (actualWidth && actualHeight) {
        setIsVertical(actualWidth < actualHeight);

        setAspectRatio(`${actualWidth} / ${actualHeight}`);
        setLoading(false);
        return;
      }

      if (type === "VIDEO" && getVideoAspect) {
        const metadata = await getVideoAspect(src);

        if (metadata.width && metadata.height) {
          setIsVertical(metadata.width < metadata.height);
          setAspectRatio(`${metadata.width} / ${metadata.height}`);
        }
        setLoading(false);
        return;
      }
    },
    [loading]
  );

  return { aspectRatio, calculateAspectRatio, isVertical };
}
